import axios from "axios"
import { ApiResponse } from "../types/global/apiTypes"

const handleAxiosError = (error: unknown): ApiResponse<any> => {
  if (axios.isAxiosError(error)) {
    return {
      statusCode: error.response?.status || 500,
      error: {
        Message: error.message,
        StatusCode: error.response?.status || 500,
      },
    }
  }
  return {
    statusCode: 500,
    error: {
      Message: 'Erro desconhecido na comunicação com o servidor.',
      StatusCode: 500,
    },
  }
}

export default handleAxiosError